import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AssetItem from '../../../components/asset/asset-item';
import {
  AssetItemHeaderDescription,
} from '../../../components/asset/asset-item/asset-item-header';
import {
  AssetItemDataText,
  AssetItemHeaderChange,
} from '../../../components/asset/asset-item/asset-item-data';

import TableRow from '../../../components/common/table-row';
import { Large } from '../../../components/common/text';

import { factory } from '../positions/asset-position/asset-position-container';
import { Percent } from '../../../components/common/number';

import styles from '../positions/asset-position/asset-position.styles';

class AssetPosition extends PureComponent {
  static propTypes = {
    row: PropTypes.shape({
      security: PropTypes.shape({ name: PropTypes.string }),
      marketValue: PropTypes.number,
      amount: PropTypes.number,
      currency: PropTypes.string,
      proportion: PropTypes.number,
    }),
    columnWidths: PropTypes.arrayOf(PropTypes.number).isRequired,
    screen: PropTypes.shape({
      isSmall: PropTypes.bool,
    }),
  };

  static defaultProps = {
    row: {},
    screen: {
      isSmall: false,
    },
  };

  render() {
    const { row, columnWidths, screen } = this.props;
    const {
      security,
      positionCurrency,
      marketValue,
      amount,
      proportion,
    } = row;
    var shorten = false;

    if(screen.isSmall){
      shorten = 30;
    }

    return (
      <AssetItem>
        <TableRow style={styles.topRow}>
          <TableRow.Column
            align="left"
            width={columnWidths[0] + columnWidths[1]}
            testID="description"
          >
            <AssetItemHeaderDescription
              row={{
                description: security,
              }}
              shorten={shorten}
            />
          </TableRow.Column>
          <TableRow.Column width={columnWidths[2]} />
        </TableRow>
        <TableRow style={styles.bottomRow}>
          <TableRow.Column
            align="left"
            width={columnWidths[0]}
          >
            <Large>{positionCurrency}</Large>
          </TableRow.Column>
          <TableRow.Column width={columnWidths[1]}>
            <AssetItemDataText value={amount} />
          </TableRow.Column>
          <TableRow.Column width={columnWidths[2]}>
            <AssetItemDataText value={marketValue} />
          </TableRow.Column>
          {
            !screen.isSmall &&
            <TableRow.Column width={columnWidths[3]}>
              <Percent value={proportion}/>
            </TableRow.Column>
          }
        </TableRow>
      </AssetItem>
    );
  }
}

export default factory({
  component: AssetPosition,

  rowFragmentExtend: {
    amount: true,
  },
});
